

<template>
  <div class="ccui-line-container">
    <div class="ccui-top-title line-t">运输方式</div>
    <el-form
      ref="puHuoRef"
      :model="puHuoForm"
      :rules="rules"
      label-width="200px"
      class="ccui-form"
    >
      <!-- <div class="cate-title" ref="anchor0">
        <el-form-item label="当前店铺：">
          <p>{{ puHuoForm.shopId }}</p>
        </el-form-item>
      </div> -->
      <div class="cate-title" ref="anchor0">
        <el-form-item label="运输方式：" prop="cateName">
          <span style="padding-right: 30px">{{ puHuoForm.cateName }}</span>
          <el-button
            class="default-button"
            size="mini"
            type="default-mini"
            :disabled="!!spuId"
            @click="$refs.changeCateDailog.open()"
            >添加运输方式</el-button
          >
        </el-form-item>
      </div>
    </el-form>

    <div class="ccui-top-title line-t">线路信息</div>
    <div style="max-width: 1180px">
      <SaleMsg
        v-if="spuId"
        @skuChecked="skuChecked"
        ref="anchor1"
        :saleData="saleData"
        :saleInfo="saleInfo"
        :logisticsData="logisticsData"
        :skus="skus"
        :units="units"
        :selectedCheckedCities="selectedCheckedCities"
        :checkSwitch="checkSwitch"
        :disabledEdit="true"
      ></SaleMsg>
      <SaleMsg
        v-else
        @skuChecked="skuChecked"
        ref="anchor1"
        :saleInfo="saleInfo"
        :units="units"
        :checkSwitch="checkSwitch"
      ></SaleMsg>
    </div>

    <div class="ccui-top-title line-t">基本信息</div>
    <GoodsInfo
      v-if="spuId"
      :skuKeyWords="skuKeyWords"
      :uploadForm="uploadForm"
      :goodsTitle="goodsTitle"
      ref="anchor2"
      :goodsInfo="goodsInfo"
    ></GoodsInfo>
    <GoodsInfo
      v-else
      :uploadForm="uploadForm"
      :goodsTitle="goodsTitle"
      ref="anchor2"
    ></GoodsInfo>

    <selectCate ref="changeCateDailog" @ok="changeCate" />
  </div>
</template>           
<script>
import selectCate from "./components/cateCheck";
import SaleMsg from "./components/sale-msg";
import GoodsInfo from "./components/goods-info";
import {
  getLogisticsGoodsInfo,
  createLogisticsCommodity,
  modifyLogisticsCommodity,
  queryCreatingLogisticsCommodity,
  queryBaseInfo,
  queryLogisticsSaleInfo,
  queryGoodInfoAndSaleAfter,
} from "@/views/lessor-open-shop/api.js";

export default {
  name: "Line",
  components: {
    selectCate,
    SaleMsg,
    GoodsInfo,
  },
  data() {
    return {
      shopInfo: {},
      saleData: {},
      logisticsData: [],
      skus: [],

      selectedCheckedCities: [],
      skuKeyWords: "",
      goodsInfo: {},
      puHuoForm: {
        shopId: "",
        cateName: "",
      },
      code: "",
      spuId: "",
      buttonId: 1, //保存并校验
      goodsTitle: "",
      uploadForm: [],
      baseInfo: {},
      saleInfo: [],
      units: {},
      checkSwitch: 0,
      rules: {
        shopId: [{ required: true, message: "请选择店铺", trigger: "change" }],
        cateName: [
          { required: true, message: "请选择运输方式", trigger: "change" },
        ],
      },
    };
  },
  computed: {},
  mounted() {
    // this.getShopInfo();
  },

  methods: {
    getShopInfo() {
      const val = sessionStorage.getItem("shopInfo")
        ? JSON.parse(sessionStorage.getItem("shopInfo"))
        : {};
      this.shopInfo = val;
      this.puHuoForm.shopId = val.shopId || "";
      localStorage.setItem("shopId", this.puHuoForm.shopId);
      queryCreatingLogisticsCommodity({
        shopId: val.shopId,
      }).then((res) => {
        const da = res.data.data;
        if (da.exists) {
          const creatingSpuBOList = da.creatingSpuBOList;
          //是否存在编辑
          this.spuId = creatingSpuBOList&&creatingSpuBOList.length > 0? creatingSpuBOList[0].spuId : da.spuId;
          this._getGoodsInfo();
        } else {
          this.spuId = "";
        }
      });
    },
    skuChecked(newList) {
      this.uploadForm = newList;
    },
    changeCate(val) {
      console.log(val, "*-*-s*d-*d-s*d-sa*d-*s-*d-*");
      this.code = val[3];
      // this.$router.push("/goods/cy-goodsdistribution/select-cate");
      this.getGoodsInfo();
    },
    // 查编辑信息
    _getGoodsInfo() {
      let params = {
        flag: 2, //1-仅查看   2-编辑查看
        isShowLoading: true,
        spuId: this.spuId,
      };
      queryBaseInfo(params).then((res) => {
        this.skuKeyWords = res.data.data.skuKeyWords;

        // this.baseInfo = res.data.data.skuProps
        this.cateName = res.data.data.classifyNamePath;
        this.puHuoForm.cateName = res.data.data.classifyNamePath;

        this.code = res.data.data.classifyCode;
        let baseInfo = { classifyPropNames: [] };
        res.data.data.skuProps.forEach((item) => {
          item.propValues.forEach((obj) => {
            obj.classifyPropValueId = obj.propValueId;
            obj.classifyPropValue = obj.propValue;
          });
          baseInfo.classifyPropNames.push({
            classifyPropName: item.propName,
            classifyPropNameId: item.propNameId,
            skuPropId: item.skuPropId,
            classifyPropValues: item.propValues,
            isRequired: item.isRequired,
            maxLength: item.maxLength,
            propEditClassify: item.propEditClassify,
          });
        });
        this.baseInfo = JSON.parse(JSON.stringify(baseInfo));
        console.log("🚀 ~ getBaseInfo ~ this.baseInfo:", this.baseInfo);
        this.isShow = true;
        // this.getGoodsInfo();
      });

      queryLogisticsSaleInfo(params).then((res) => {
        if (res.data.data.approveStatus !== 0) {
          this.previewShow = true;
        } else {
          this.previewShow = false;
        }
        this.selectedCheckedCities = res.data.data.applyArea.addressCodes;
        res.data.data.propNames.forEach((obj) => {
          obj.propValues.forEach((item) => {
            item.classifyPropValue = item.propValue;
            item.classifyPropValueId = item.propValueId;
          });
          obj.classifyPropName = obj.propName;
          obj.classifyPropNameId = obj.propNameId;
          obj.classifyPropValues = obj.propValues;
        });
        this.saleInfo = res.data.data.propNames;
        this.skus = res.data.data.skus;
        this.saleData = res.data.data;
        this.checkSwitch = res.data.data.checkSwitch;
        this.newSkuId =
          this.saleData.skus.length > 0
            ? this.saleData.skus[0].skuId
            : this.saleData.skuId;
        this.units = {
          unitCode: res.data.data.skus[0].unitCode,
          unitName: res.data.data.skus[0].unitName,
          basicUnitCode: res.data.data.basicUnitCode,
          basicUnitName: res.data.data.basicUnitName,
          units: res.data.data.units,
          unitRateBO: res.data.data.unitRateBO,
        };
        // 组装路线
        this.logisticsData = res.data.data.spuLogisticsBO.map((item) => {
          const {
            originProvinceName,
            originCityName,
            destinationProvinceName,
            destinationCityName,
            originProvinceId,
            originCityId,
            destinationProvinceId,
            destinationCityId,
            spuLogisticsId,
            spuId,
          } = item;
          return {
            id: spuId,
            spuLogisticsId,
            startRouteName: [originProvinceName, originCityName],
            startRouteCode: [originProvinceId, originCityId],
            endRouteName: [destinationProvinceName, destinationCityName],
            endRouteCode: [destinationProvinceId, destinationCityId],
          };
        });
      });

      queryGoodInfoAndSaleAfter(params).then((res) => {
        setTimeout(() => {
          this.isShow = false;
          this.goodsInfo = res.data.data.goodInfo;
          this.isShow = true;
        }, 200);
      });
    },

    getGoodsInfo() {
      let classifyCode = this.code;
      // let classifyCode = "10110812166"
      getLogisticsGoodsInfo({
        classifyCode,
        shopId: this.puHuoForm.shopId,
        isShowLoading: true,
      }).then((res) => {
        const das = res.data.data;
        this.puHuoForm.cateName = das.classifyNamePath;
        this.baseInfo = das.baseInfo;
        this.saleInfo = das.saleInfo.classifyPropNames;
        this.units = das.saleInfo;
        this.checkSwitch = das.checkSwitch;
        console.log(this.baseInfo);
      });
    },
    //保存校验
    saveValid(state) {
      this.buttonId = state;
      if (state === 0) {
        this.saveSubmit();
        return;
      }
      this.$refs.puHuoRef.validate((valid) => {
        if (valid) {
          this.$refs.anchor1.submitValid();
          this.$refs.anchor2.submitValid();
          this.$nextTick(() => {
            const errorFormEl = document.body.querySelectorAll(".is-error");
            if (errorFormEl.length) {
              if (
                document.body.querySelectorAll(".el-table-form-item.is-error")
                  .length
              ) {
                let $table = document.body.querySelector(".el-table");
                document.documentElement.scrollTop = $table.offsetTop;
              } else {
                document.documentElement.scrollTop = errorFormEl[0].offsetTop;
              }
            } else {
              if (!!window.ActiveXObject || "ActiveXObject" in window) {
                //判断是不是IE
                console.log("IE浏览器");
                var saleInfo = this.$refs.anchor1;
                saleInfo.attrForm.tableData.forEach((item, index) => {
                  if (
                    !item.minSaleCount ||
                    !item.salePrice ||
                    !item.stockNum ||
                    !item.taxCode ||
                    !item.taxInfo
                  ) {
                    this.breakSubmit = true;
                    let $table = document.body.querySelector(".sku-table");
                    document.documentElement.scrollTop = $table.offsetTop;
                    try {
                      throw Error();
                    } catch (e) {
                      console.log(e);
                    }
                  }
                });
                if (this.breakSubmit) {
                  this.breakSubmit = false;
                  return;
                }
              }
              console.log("验证通过");
              if (this.spuId) {
                this.editSaveSubmit();
              } else {
                this.saveSubmit();
              }
            }
          });
        } else {
          document.documentElement.scrollTop = 0
          return false;
        }
      });
    },
    //保存并提交
    saveSubmit() {
      let submitData = {
        buttonId: this.buttonId,
        shopId: this.puHuoForm.shopId,
        classifyCode: this.code,
        classifyName: "",
        goodsInfoReqBO: {
          pictures: [],
        },
        skuBaseInfoReqBO: {
          skuProps: [],
        },
        skuSaleInfoReqBO: {
          applyArea: {
            isAll: 0,
            provinces: [],
          },
          unitRateBO: {},
          skus: [],
        },
        afterSaleReqBO: {
          saleAfterIds: [],
        },
      };
      //商品信息
      let goodsInfo = this.$refs.anchor2;
      let getDomJson = goodsInfo.$refs.elKindeditor.content;
      submitData.goodsInfoReqBO.detailPc = getDomJson ? getDomJson : "";

      submitData.goodsInfoReqBO.spuPromo = goodsInfo.form.spuPromo;
      submitData.goodsInfoReqBO.spuTitle = goodsInfo.form.spuTitle;
      console.log(goodsInfo.fileList);
      goodsInfo.fileList.forEach((item, index) => {
        submitData.goodsInfoReqBO.pictures.push({
          picType: index + 1,
          uploadId: item.response.data[0].uploadId,
        });
      });

      // 基础信息
      submitData.skuBaseInfoReqBO.skuProps =
        this.baseInfo.classifyPropNames.map(
          ({ classifyPropName, classifyPropGroupId, classifyPropNameId }) => {
            let propValue = "";
            switch (classifyPropName) {
              case "品牌":
                propValue = "物流品牌";
                break;
              case "产地":
                propValue = "中国大陆";
                break;
              default:
                break;
            }
            return {
              isSearch: "0",
              propGroupId: classifyPropGroupId,
              propName: classifyPropName,
              propNameId: classifyPropNameId,
              propValue,
            };
          }
        );

      //销售信息
      let saleInfo = this.$refs.anchor1;
      console.log("🚀 ~ saveSubmit ~ saleInfo:", saleInfo);

      submitData.skuSaleInfoReqBO.supplier = this.shopInfo.businessName;
      submitData.skuSaleInfoReqBO.supplierId = this.shopInfo.businessId;
      //   submitData.skuSaleInfoReqBO.supplier = !saleInfo.attrForm.supplierObj
      //     ? ""
      //     : saleInfo.attrForm.supplierObj.label;
      //   submitData.skuSaleInfoReqBO.supplierId = !saleInfo.attrForm.supplierObj
      //     ? ""
      //     : saleInfo.attrForm.supplierObj.value;
      if (
        saleInfo.attrForm.applyArea.isAll === 0 &&
        !saleInfo.checkedCities2.length
      ) {
        this.$message({
          message: "请添加适用区域",
          type: "error",
          ccuiCustom: true,
          showClose: true,
        });
        return;
      }
      submitData.skuSaleInfoReqBO.applyArea.isAll =
        saleInfo.attrForm.applyArea.isAll;
      submitData.skuSaleInfoReqBO.applyArea.addressCodes =
        saleInfo.checkedCities2;
      console.log(submitData.skuSaleInfoReqBO.applyArea.addressCodes);

      console.log(
        "🚀 ~ saleInfo.tableData.forEach ~ saleInfo.tableData:",
        saleInfo.attrForm.tableData
      );
      saleInfo.attrForm.tableData.forEach((item, index) => {
        const valueIds = saleInfo.classifyPropKeys.map(
          (n) => item[n].classifyPropValueId
        );
        const { startRouteName, startRouteCode, endRouteName, endRouteCode } =
          item.spuRouteObj;
        const {
          basicRate,
          basicUnitCode,
          basicUnitName,
          unitCode,
          unitName,
          converRate,
        } = item.tabUnitObj;
        const unitRateBO = {
          basicRate,
          basicUnitCode,
          basicUnitName,
          converUnitCode: unitCode,
          converUnitName: unitName,
          converRate,
        };
        let sku = {};
        sku.originProvinceName = startRouteName[0];
        sku.originCityName = startRouteName[1];
        sku.destinationProvinceName = endRouteName[0];
        sku.destinationCityName = endRouteName[1];
        sku.originProvinceId = startRouteCode[0];
        sku.originCityId = startRouteCode[1];
        sku.destinationProvinceId = endRouteCode[0];
        sku.destinationCityId = endRouteCode[1];

        sku.propNameJoin = item.propNameJoin;
        sku.minSaleCount = item.minSaleCount;
        sku.salePrice = item.salePrice;
        sku.stockNum = item.stockNum;
        sku.taxCode = item.taxCode;
        sku.taxInfo = item.taxInfo;
        sku.skuMats = item.skuMats;
        sku.unitRateBO = unitRateBO;
        sku.valueIds = valueIds;
        sku.pictures = [];
        try {
          if (goodsInfo.$refs["upload" + index][0]["fileList"]) {
            goodsInfo.$refs["upload" + index][0].fileList.forEach((val, i) => {
              let obj = {};
              obj.picType = i + 1;
              obj.uploadId = val.response.data[0].uploadId;
              sku.pictures.push(obj);
            });
          }
        } catch (e) {
          console.log(e);
        }
        submitData.skuSaleInfoReqBO.skus.push(sku);
      });

      submitData.goodsInfoReqBO.skuKeyWords =
        this.$refs.anchor2.dynamicTags.join(",");
      submitData.isShowLoading = true;
      //   submitData.shopAgentId = this.puHuoForm.shopAgentId;
      //   submitData.addSource = 1;

      console.log(submitData);
      createLogisticsCommodity(submitData)
        .then((res) => {
          if (res.data.code === "0") {
            var messageSentence =
              this.buttonId == 2
                ? "商品保存并提交成功"
                : this.buttonId == 1
                ? "提交运力线路成功"
                : this.buttonId == 0
                ? "暂存成功"
                : "操作成功";
            this.$message({
              showClose: true,
              message: messageSentence,
              ccuiCustom: true,
              offset: document.documentElement.clientHeight / 2,
              type: "success",
            });
            // this.getShopInfo() //新增后从新获取走编辑逻辑
            this.$emit("success", 'add');
          }
        })
        .catch((e) => {
          if (this.checkSwitch == 1 && e.data.code == "20202") {
            this.$message({
              showClose: true,
              message:
                "提示：因店铺对账设置已开启，供货商和进货价字段必须填写！",
              ccuiCustom: true,
              offset: document.documentElement.clientHeight / 2,
              type: "error",
            });
          }
        });
    },
    //保存并提交
    editSaveSubmit() {
      let submitData = {
        buttonId: this.buttonId,
        shopId: this.puHuoForm.shopId,
        classifyCode: this.code,
        classifyName: "",
        goodsInfoReqBO: {
          pictures: [],
        },
        skuBaseInfoReqBO: {
          skuProps: [],
        },
        skuSaleInfoReqBO: {
          applyArea: {
            isAll: 0,
            provinces: [],
          },
          unitRateBO: {},
          skus: [],
        },
        spuId: this.spuId,
        skuId: '',
      };

      //基本信息
      submitData.skuBaseInfoReqBO.skuProps =
        this.baseInfo.classifyPropNames.map((item) => {
          const curPropValueItem = item.classifyPropValues.find(
            (n) => n.choose
          );
          return {
            isSearch: "0",
            propGroupId: item.classifyPropNameId, // 返回的数据中没有，待商榷
            propName: item.classifyPropName,
            propNameId: item.classifyPropNameId,
            propValue: curPropValueItem ? curPropValueItem.propValue : "流品牌",
          };
        });

      //商品信息
      let skuPicIdsUpdate = [];
      let goodsInfo = this.$refs.anchor2;
      let getDomJson = goodsInfo.$refs.elKindeditor.content;

      submitData.goodsInfoReqBO.detailPc = getDomJson ? getDomJson : "";

      submitData.goodsInfoReqBO.spuPromo = goodsInfo.form.spuPromo;
      submitData.goodsInfoReqBO.spuTitle = goodsInfo.form.spuTitle;
      console.log(goodsInfo.fileList);
      goodsInfo.fileList.forEach((item, index) => {
        skuPicIdsUpdate.push(item.response.data[0].skuPicId);
        submitData.goodsInfoReqBO.pictures.push({
          picType: index + 1,
          uploadId: item.response.data[0].uploadId,
          skuPicId: item.response.data[0].skuPicId,
        });
      });

      //销售信息
      let saleInfo = this.$refs.anchor1;

      submitData.skuSaleInfoReqBO.supplier = this.shopInfo.businessName;
      submitData.skuSaleInfoReqBO.supplierId = this.shopInfo.businessId;

    //   submitData.skuSaleInfoReqBO.supplier = !saleInfo.attrForm.supplierObj
    //     ? ""
    //     : saleInfo.attrForm.supplierObj.label;
    //   submitData.skuSaleInfoReqBO.supplierId = !saleInfo.attrForm.supplierObj
    //     ? ""
    //     : saleInfo.attrForm.supplierObj.value;
      if (
        saleInfo.attrForm.applyArea.isAll === 0 &&
        !saleInfo.checkedCities2.length
      ) {
        this.$message({
          message: "请添加适用区域",
          type: "error",
          ccuiCustom: true,
          showClose: true,
        });
        return;
      }
      submitData.skuSaleInfoReqBO.applyArea.isAll =
        saleInfo.attrForm.applyArea.isAll;
      submitData.skuSaleInfoReqBO.applyArea.addressCodes =
        saleInfo.checkedCities2;
      saleInfo.attrForm.tableData.forEach((item, index) => {
        const valueIds = saleInfo.classifyPropKeys.map(
          (n) => item[n].classifyPropValueId
        );
        const { startRouteName, startRouteCode, endRouteName, endRouteCode } =
          item.spuRouteObj;
        const {
          basicRate,
          basicUnitCode,
          basicUnitName,
          unitCode,
          unitName,
          converRate,
        } = item.tabUnitObj;
        const unitRateBO = {
          basicRate,
          basicUnitCode,
          basicUnitName,
          converUnitCode: unitCode,
          converUnitName: unitName,
          converRate,
        };
        let sku = {};
        sku.originProvinceName = startRouteName[0];
        sku.originCityName = startRouteName[1];
        sku.destinationProvinceName = endRouteName[0];
        sku.destinationCityName = endRouteName[1];
        sku.originProvinceId = startRouteCode[0];
        sku.originCityId = startRouteCode[1];
        sku.destinationProvinceId = endRouteCode[0];
        sku.destinationCityId = endRouteCode[1];

        sku.propNameJoin = item.propNameJoin;
        sku.minSaleCount = item.minSaleCount;
        sku.salePrice = item.salePrice;
        sku.stockNum = item.stockNum;
        sku.taxCode = item.taxCode;
        sku.taxInfo = item.taxInfo;
        sku.skuMats = item.skuMats;
        sku.unitRateBO = unitRateBO;
        sku.valueIds = valueIds;
        sku.pictures = [];
        if (goodsInfo.$refs["upload" + index][0]["fileList"]) {
          goodsInfo.$refs["upload" + index][0].fileList.forEach((val, i) => {
            skuPicIdsUpdate.push(val.response.data[0].skuPicId);
            let obj = {};
            obj.picType = i + 1;
            obj.uploadId = val.response.data[0].uploadId;
            obj.skuPicId = val.response.data[0].skuPicId;
            sku.pictures.push(obj);
          });
        }
        submitData.skuSaleInfoReqBO.skus.push(sku);
      });
      submitData.skuSaleInfoReqBO.deleteSkuIds = [];

      //查询删除的图片Id
      let deleteskuPicId = [];
      goodsInfo.skuPicIds.forEach((item) => {
        if (skuPicIdsUpdate.indexOf(item) == -1) {
          deleteskuPicId.push(item);
        }
      });
      submitData.goodsInfoReqBO.deletePictureIds = deleteskuPicId;

      //售后服务
      submitData.goodsInfoReqBO.skuKeyWords =
        this.$refs.anchor2.dynamicTags.join(",");
    //   (submitData.shopAgentId = this.$route.query.shopAgentId),
    //     (submitData.addSource = 1);
      submitData.isShowLoading = true;

      console.log(submitData);
      modifyLogisticsCommodity(submitData)
        .then((res) => {
          console.log(res, "res");
          console.log(submitData, "submitData");
          if (res.data.code === "0") {
            var messageSentence =
              this.buttonId == 2
                ? "商品提交成功"
                : this.buttonId == 1
                ? "商品保存成功"
                : this.buttonId == 0
                ? "商品暂存成功"
                : "商品操作成功";
            this.$message({
              showClose: true,
              message: messageSentence,
              ccuiCustom: true,
              offset: document.documentElement.clientHeight / 2,
              type: "success",
            });
            this.$emit("success", 'edit');
            if (this.buttonId === 0) {
              //暂存后变为草稿状态，无法商品预览
              this.previewShow = false;
            } else {
              this.previewShow = true;
            }
            if (this.buttonId !== 0) {
              this.newSkuId = res.data.data.skuId;
            }
            
          }
        })
        .catch((e) => {
          if (this.checkSwitch == 1 && e.data.code == "20202") {
            this.$message({
              showClose: true,
              message:
                "提示：因店铺对账设置已开启，供货商和进货价字段必须填写！",
              ccuiCustom: true,
              offset: document.documentElement.clientHeight / 2,
              type: "error",
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.line-t {
  margin-left: 100px;
  margin-top: 20px;
}
.combtn {
  margin-bottom: 20px;
  font-family: PingFangSC-Semibold, PingFangSC;
  font-weight: 600;
}
</style>